<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="30rem"
  >
    <template v-slot:activator="{ on: dialog }">
      <v-btn v-on="{ ...dialog }" icon small>
        <v-icon small>fa-plus</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="px-1 pt-1">
        <v-row justify="space-between" no-gutters>
          <v-spacer></v-spacer>
          <v-btn small icon text @click="dialog = false" :disabled="loading">
            <v-icon small>fa-times</v-icon>
          </v-btn>
        </v-row>
      </v-card-title>
      <v-form v-model="valid" ref="form" @submit.prevent="save">
        <v-card-text class="pb-0">
          <v-text-field
            ref="input"
            class="no-before"
            filled
            v-model="tag"
            @change="onChange"
            label="Mot clé à ajouter"
            :disabled="loading"
            required
          ></v-text-field>

          <v-row align="center" class="my-3" v-show="loading">
            <v-progress-linear
              indeterminate
              color="primary"
            ></v-progress-linear>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-row align="center" justify="space-between" no-gutters>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :outlined="$vuetify.breakpoint.xsOnly"
              :text="!$vuetify.breakpoint.xsOnly"
              @click="dialog = false"
              :disabled="loading"
            >
              Annuler
            </v-btn>
            <v-btn
              :block="$vuetify.breakpoint.xsOnly"
              :small="!$vuetify.breakpoint.xsOnly"
              :class="{ 'mt-3': $vuetify.breakpoint.xsOnly }"
              color="success"
              :disabled="!valid || loading"
              type="submit"
            >
              Ajouter
            </v-btn>
          </v-row>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { api } from "@/api";
export default {
  name: "TagManagerTagAdder",
  props: {
    item: {
      required: true
    }
  },
  data() {
    return {
      tag: null,
      tagValue: "",
      dialog: false,
      loading: false,
      valid: false
    };
  },
  methods: {
    async save() {
      if (this.valid) {
        try {
          this.loading = true;
          const newTagsArray = [...this.item.tags, this.tagValue];
          const d = {
            ...this.item,
            tags: newTagsArray
          };
          const res = await api.patchTagCategory(this.item.id, d);
          this.$store.commit("updateTagCategory", res);
          this.dialog = false;
        } finally {
          this.loading = false;
        }
      }
    },
    onChange(v) {
      if (v.length > 0 && v.charAt(0) === "#") {
        this.tagValue = v;
      } else if (v.length > 0 && v.charAt(0) !== "#") {
        this.tagValue = `#${v}`;
      } else {
        this.tagValue = v;
      }
    }
  },
  watch: {
    dialog(v) {
      if (v === false) {
        this.$refs.form.reset();
      } else {
        setTimeout(() => this.$refs.input.focus(), 150);
      }
    }
  }
};
</script>

<style></style>
